import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { markFormGroupTouched } from '@core/helpers';
import { TabComponent } from '../interfaces/tab-component';

@Injectable({
  providedIn: 'root',
})
export class TabMenuService {
  private instancesMap = new Map<string|number, TabComponent>();
  private instancesSubject = new BehaviorSubject<TabComponent[]>([]);
  private formValidSubject = new BehaviorSubject<boolean>(false);
  
  instances$ = this.instancesSubject.asObservable();
  formValid$ = this.formValidSubject.asObservable();

  constructor() {}

  registerForm(instance: TabComponent): void {
    if (!instance?.tabId) return;
    this.instancesMap.set(instance?.tabId, instance);
    this.updateInstancesSubject();
  }

  validateTab(tabId: string|number): boolean {
    const instance = this.instancesMap.get(tabId);
    if (instance && instance.formGroup) {
      markFormGroupTouched(instance.formGroup, true);
      
      return instance.formGroup.valid;
    }
    return true;
  }

  validateAllTabs(): boolean {
    let allValid = true;
    
    this.instancesMap.forEach((_, tabId) => {
      const isValid = this.validateTab(tabId);
      if (!isValid) allValid = false;
    });
    
    return allValid;
  }

  getTabInstance(tabId: number): TabComponent | undefined {
    return this.instancesMap.get(tabId);
  }

  isFormValid(tabIds: (string|number)[]): boolean {
    let allValid = true;
    
    tabIds.forEach(tabId => {
      const isValid = this.validateTab(tabId);
      if (!isValid) allValid = false;
    });
    
    return allValid;
  }

  unregisterForm(tabId: number): void {
    this.instancesMap.delete(tabId);
    this.updateInstancesSubject();
  }

  clearForms(): void {
    this.instancesMap.clear();
    this.updateInstancesSubject();
    this.formValidSubject.next(false);
  }

  private updateInstancesSubject(): void {
    const instances = Array.from(this.instancesMap.values());
    this.instancesSubject.next(instances);
  }
}
